module.exports = __webpack_public_path__ + "components/flag/static/square/im-6e5c8bb55cf657a969763844f8268579.svg";